<template>
  <ul class="flex flex-wrap px-32 py-8 list-reset">
    <li
      :key="label.id"
      v-for="(label, index) in labels"
      class="my-8"
      :class="{ 'mr-16': index !== labels.length - 1 }"
    >
      <button
        v-test="{ id: 'editor-tabs-button' }"
        @click="onClick(index)"
        :class="[
          current === index
            ? 'bg-nebula-blue'
            : 'hover:bg-moon-grey-transparent focus:bg-moon-grey-transparent cursor-pointer'
        ]"
        class="py-8 px-16 rounded-sm focus:outline-none transition transition-fast transition-in-out text-white leading-tight cursor-default"
      >
        {{ label.label }}
      </button>
    </li>
  </ul>
</template>

<script>
export default {
  props: {
    labels: {
      type: Array,
      required: true
    },
    current: {
      type: Number,
      default: 0
    },
    onClick: {
      type: Function,
      required: true
    }
  }
}
</script>
